import { Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { CSSProperties, useState } from "react";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

const inputStyle: CSSProperties = {
  fontSize: "16px",
  borderRadius: "8px",
  height: "50px",
  alignItems: "center",
};

function AntDInputField({
  name,
  rules,
  className,
  type,
  value,
  placeholder,
  size,
}: any) {
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
  const [inputType, setInputType] = useState<string>("password");

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
    setInputType(passwordVisible ? "password" : "text");
  };
  return (
    <div>
      <Form.Item
        name={name}
        rules={rules}
        className={`mt-3 mb-8 ${className ? className : ""}`}
      >
        {name === "bio" || name === "description" ? (
          <TextArea
            showCount
            maxLength={100}
            style={{ height: 80 }}
            defaultValue={value}
            className="ayozat-dark-input"
          />
        ) : type === "password" ? (
          <Input
            type={inputType}
            placeholder={placeholder}
            style={inputStyle}
            className="ayozat-dark-input"
            suffix={
              <div
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? (
                  <EyeTwoTone className="text-lg" />
                ) : (
                  <EyeInvisibleOutlined className="text-lg text-white/50" />
                )}
              </div>
            }
          />
        ) : (
          <Input
            style={inputStyle}
            type={"text"}
            defaultValue={value}
            size={size}
            placeholder={placeholder}
            className="ayozat-dark-input"
          />
        )}
      </Form.Item>

      {/* dark theme for antd inputs */}
      <style>{`
        .ayozat-dark-input,
        .ayozat-dark-input.ant-input,
        .ayozat-dark-input .ant-input,
        .ayozat-dark-input.ant-input-affix-wrapper {
          background-color: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.12) !important;
          color: #fff !important;
          box-shadow: none !important;
        }
        .ayozat-dark-input .ant-input {
          border: none !important;
          background-color: transparent !important;
        }
        .ayozat-dark-input::placeholder,
        .ayozat-dark-input .ant-input::placeholder {
          color: rgba(255, 255, 255, 0.4) !important;
        }
        .ayozat-dark-input:hover,
        .ayozat-dark-input.ant-input-affix-wrapper:hover {
          border-color: rgba(255, 255, 255, 0.3) !important;
        }
        .ayozat-dark-input:focus,
        .ayozat-dark-input.ant-input-affix-wrapper-focused {
          border-color: var(--red, #f30543) !important;
          box-shadow: 0 0 0 2px rgba(243, 5, 67, 0.15) !important;
        }
        /* character counter under TextArea */
        .ayozat-dark-input .ant-input-data-count {
          color: rgba(255, 255, 255, 0.4) !important;
        }
      `}</style>
    </div>
  );
}

export default AntDInputField;